var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox checkbox-css"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isChecked,"value":_vm.value},on:{"change":event => _vm.onChange(event)}}),_c('label',{on:{"click":event => event.target.previousSibling.click()}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }